import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TabItem } from '../models/tabs-models';
import { Router, RouterLink, RouterLinkActive, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';



@Component({
  selector: 'app-tabs',
  imports: [CommonModule,RouterModule,TranslatePipe],
  templateUrl: './tabs.html',
  styleUrl: './tabs.css',
})
export class Tabs {
  @Input() tabs: TabItem[] = [];
  constructor(private router: Router) { }

  get activeRoute(): string {
    return this.router.url;
  }
  @Input() active: any;
  @Output() tabChange = new EventEmitter<any>();

  selectTab(value: any) {
    this.tabChange.emit(value);
  }

  onTabChange(event: Event): void {
    const route = (event.target as HTMLSelectElement).value;
    this.router.navigateByUrl(route);
  }
  onTabClick(tab: TabItem) {
  if (tab.disabled) {
    console.log('Please generate lead first');
    return;
  }

  this.router.navigate([tab.route], {
    queryParams: tab.queryParams
  });
}isActive(tab: TabItem): boolean {
  return this.router.url.includes(tab.route);
}
}
